module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"interviewOnline":"Онлайн интервью","officeInterview":"Очное интервью","online_interview":"Автоматическое интервью","video_call":"Видеозвонок","office_interview":"Встречу в офисе","uploaded_video":"Файл с видео"}}')
  delete Component.options._Ctor
}
